import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Section from 'components/common/Section';
import HeaderSCSLayout from 'components/headerCard/HeaderSCS';

interface ErrorLayoutProps {
  children: React.ReactNode;
}

const ErrorLayout: React.FC<ErrorLayoutProps> = ({ children }) => {
  return (
    <Section className="py-0">
      <Row className="flex-center min-vh-100 py-6">
        <Col sm={11} md={9} lg={7} xl={6} className="col-xxl-5">
          <HeaderSCSLayout />
          {children}
        </Col>
      </Row>
    </Section>
  );
};

export default ErrorLayout;
